import { has } from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createLocalizationProvider } from '@mews/framework';
import { localizationMapper } from '../../mappers/localizationMapper';

const BaseLocalizationProvider = createLocalizationProvider({
    localizationHandlerNames: [
        'localizeText',
        'localizeProperty',
        'localizeDate',
        'localizeShortDate',
        'localizeShortTime',
        'localizeCurrencyValue',
        'localizePercent',
    ],
});

const LocalizationProviderWrapper = (LocalizationComponent: $TSFixMe) =>
    class extends Component {
        component: $TSFixMe;
        componentDidUpdate(prevProps: $TSFixMe) {
            if (prevProps.currencyCode !== (this.props as $TSFixMe).currencyCode) {
                if (has(this, 'component.triggerUpdate')) {
                    this.component.triggerUpdate();
                }
            }
        }

        componentRef = (c: $TSFixMe) => (this.component = c);

        render() {
            return <LocalizationComponent ref={this.componentRef} {...this.props} />;
        }
    };

export const LocalizationProvider = connect(localizationMapper)(LocalizationProviderWrapper(BaseLocalizationProvider));
